/* === SYSTEM OFFER BLOCK — live state from the cart ========================
 *
 * Ported from the reference app's OfferBlock + ShippingProgress, which read a
 * client cart context. Liquid has no such context, so this reads /cart.js and
 * recomputes on every cart event the theme already broadcasts.
 *
 * The SERVER renders the zero state, so the block is correct and complete
 * before this file runs and stays correct if it never does. Nothing here
 * creates content — it only updates numbers that are already on the page.
 * ========================================================================= */
(function () {
  'use strict';

  /* THE CYCLE IS DERIVED, NOT TYPED. These were `BUY = 3` / `GROUP = 4`, a
     SECOND source of truth for the offer sitting beside window.UMAI_OFFER — so
     flipping the offer in snippets/umai-offer.liquid left this file still
     drawing a four-slot meter for a buy-2 offer. The offer's own compute()
     reports its cycle as the denominator of `count` ("1 / 3"), which is the
     same signal sections/system-bundle-showcase.liquid reads. Fall back to the
     old literals only if UMAI_OFFER is absent. */
  var GROUP = 4, BUY = 3;
  try {
    var _o = window.UMAI_OFFER;
    var _c = _o && _o.compute && _o.compute(0).count;      /* e.g. "1 / 3" */
    var _d = _c && parseInt(String(_c).split('/')[1], 10);
    if (_d > 1) { GROUP = _d; BUY = _d - 1; }
  } catch (e) { /* keep the fallback */ }

  var root = document.querySelector('[data-sys-offer]');
  if (!root) return;

  /* COPY. snippets/umai-i18n.liquid exports the translated table; every lookup
     below keeps its English literal as a fallback so a missing key — or a
     stale cache that drops the bridge entirely — degrades to English rather
     than blanking a line the shopper is reading. The literals here are the
     SAME sentences snippets/system-offer-block.liquid renders server-side, and
     the two have to move together: this file overwrites that markup on the
     first cart read, so a mismatch shows as a flash from one to the other.
     Counts and amounts arrive as literal [n] / [amount] tokens rather than
     being concatenated — word order round a number is not English's to set. */
  var I18N = window.UMAI_I18N || {};
  function t(key, en, tokens) {
    var s = I18N[key] || en;
    if (tokens) {
      for (var k in tokens) s = s.split('[' + k + ']').join(tokens[k]);
    }
    return s;
  }

  /* The gate is authored in USD CENTS and must be CONVERTED before it is
     compared with, or printed beside, a cart subtotal — cart.js reports the
     subtotal in the SHOPPER'S currency. Without this, a EUR cart of 8700
     (=87 EUR, which really is ~$100) was measured against 10000 and told the
     shopper they had not qualified; the goal also printed as "100 EUR" when the
     real gate is ~87 EUR. The fallback was 8000, a stale $80, and the attribute
     was never emitted at all, so this ran on $80 for every shopper.
     NOTE this is the opposite treatment to the FLAT shipping rate, which is a
     fixed per-market price and must never be converted. */
  var SHIP_USD = Number(root.getAttribute('data-ship-threshold') || 10000);
  var _rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate)) || 1;
  var SHIP = Math.round(SHIP_USD * _rate);

  var elCount = root.querySelector('[data-sys-offer-count]');
  var elMsg   = root.querySelector('[data-sys-offer-msg]');
  var elCap   = root.querySelector('[data-sys-offer-freecap]');
  /* RECONCILE THE METER TO THE ACTIVE OFFER.
     The segments and their captions are server-rendered from a hardcoded
     `so_group` in snippets/system-offer-block.liquid. That was a FOURTH copy of
     the offer's cycle (after this file, snippets/umai-offer.liquid and
     snippets/cart-drawer.liquid): when the store moved to Buy 2 Get 1 Free the
     Liquid still emitted FOUR segments while GROUP became 3, so at 3 tees the
     shopper had earned the free one and the bar still showed a dark fourth
     slot — "not complete" — while the cart was correct. Ryan hit this.
     Rather than trust the markup, trim or clone to match GROUP. Cloning copies
     the caption node too, so the FREE cap stays under the last segment. */
  (function reconcileMeter(){
    var segWrap = root.querySelector('.sys-offer__segs');
    var capWrap = root.querySelector('.sys-offer__caps');
    if (!segWrap) return;
    function fit(wrap, cls){
      if (!wrap) return;
      var kids = [].slice.call(wrap.children);
      while (kids.length > GROUP) { wrap.removeChild(kids.pop()); }
      while (kids.length < GROUP && kids.length) {
        var clone = kids[0].cloneNode(true);
        clone.className = cls;
        wrap.appendChild(clone); kids.push(clone);
      }
      /* the LAST one owns the free slot, wherever it now sits */
      kids = [].slice.call(wrap.children);
      kids.forEach(function(k,i){
        k.classList.toggle('is-free', i === kids.length - 1);
        if (k.hasAttribute('data-sys-offer-seg')) k.setAttribute('data-sys-offer-seg', String(i));
      });
    }
    fit(segWrap, 'sys-offer__seg');
    fit(capWrap, 'sys-offer__cap');
  })();

  var segs    = [].slice.call(root.querySelectorAll('[data-sys-offer-seg]'));
  var shipSegs= [].slice.call(root.querySelectorAll('[data-sys-ship-seg]'));
  var elRemain= root.querySelector('[data-sys-ship-remain]');
  var elLabel = root.querySelector('[data-sys-ship-label]');

  /* A tee is offer-eligible on the same rule the rest of the store uses:
     the title says T-Shirt and does not say Oversized. Kept identical to
     snippets/umai-offer.liquid so the PDP and the cart cannot disagree. */
  function isTee(item) {
    var t = item.product_title || item.title || '';
    return /T-Shirt/i.test(t) && !/Oversized/i.test(t);
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency) || {};
    if (cur.active && cur.active !== 'USD') {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en',
          { style: 'currency', currency: cur.active }).format(cents / 100);
      } catch (e) { /* fall through */ }
    }
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace(/<[^>]+>/g, '').replace(/\{\{\s*amount[^}]*\}\}/, amount).trim();
  }

  /* The same arithmetic as the reference's offerState(): where the shopper
     sits inside the CURRENT group of four, not across the whole basket. */
  function render(tees, subtotal) {
    var free = Math.floor(tees / GROUP);
    var inGroup = tees % GROUP;
    var justUnlocked = tees > 0 && inGroup === 0;
    var nextIsFree = inGroup === BUY;
    var bought = justUnlocked ? BUY : Math.min(inGroup, BUY);
    var earned = justUnlocked || free > 0;
    var hot = nextIsFree || free > 0;

    root.classList.toggle('is-hot', hot);

    if (elCount) {
      elCount.textContent = free > 0
        ? (free === 1
            ? t('sysoffer_one_free', '1 TEE FREE')
            : t('sysoffer_n_free', '[n] TEES FREE', { n: free }))
        : t('sysoffer_in_cart', '[n] IN CART', { n: tees });
      elCount.classList.toggle('is-on', free > 0);
    }

    segs.forEach(function (s, i) {
      var isFreeSlot = i === GROUP - 1;
      s.classList.remove('is-on', 'is-next', 'is-ghost');
      if (!isFreeSlot) { if (i < bought) s.classList.add('is-on'); return; }
      /* One tee away: a solid edge at full strength. A dashed ghost here reads
         as "locked" at exactly the moment it is about to be handed over. */
      s.classList.add(earned ? 'is-on' : nextIsFree ? 'is-next' : 'is-ghost');
    });

    if (elCap) elCap.classList.toggle('is-on', earned || nextIsFree);

    if (elMsg) {
      var toQualify = BUY - inGroup;
      elMsg.textContent = nextIsFree
        ? t('sysoffer_add_free', 'Add your free tee — the 4th is on us!')
        : justUnlocked
          ? t('sysoffer_unlocked', 'Buy 2 Get 1 Free unlocked!')
          : tees === 0
            ? t('sysoffer_start', 'Buy 2 tees, get 1 FREE')
            : t('sysoffer_more', 'Add [n] more and get 1 free', { n: toQualify });
    }

    /* "THAT TEE IS WORTH $40" was removed on Ryan's call, 2026-08-21. It also
       carried the only hardcoded price in this file (UNIT = 4000 cents), which
       asserted a $40 unit for every product regardless of what the shopper was
       actually looking at — a tee priced differently, or any non-$40 market,
       was told the wrong figure. The element stays in the markup, permanently
       hidden, so a stale cached script cannot resurrect the text. */

    /* Shipping. The LAST segment is reserved for the unlocked state: rounding
       up would light the whole meter at a cent short and tell the shopper they
       had cleared a threshold they had not. */
    var unlocked = subtotal >= SHIP;
    var remaining = Math.max(0, SHIP - subtotal);
    var progress = SHIP > 0 ? Math.min(1, subtotal / SHIP) : 0;
    var filled = unlocked ? shipSegs.length : Math.min(shipSegs.length - 1, Math.floor(progress * shipSegs.length));
    shipSegs.forEach(function (s, i) { s.classList.toggle('is-on', i < filled); });
    if (elLabel) {
      elLabel.classList.toggle('is-on', unlocked);
      if (unlocked) elLabel.textContent = t('sysoffer_ship_applied', '✓ FREE SHIPPING APPLIED');
      else if (elRemain) elRemain.textContent = money(remaining);
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var tees = 0;
        (c.items || []).forEach(function (it) { if (isTee(it)) tees += it.quantity; });
        render(tees, c.total_price || 0);
      })
      .catch(function () { /* leave the server-rendered zero state alone */ });
  }

  refresh();
  ['cart:refresh', 'cart:open', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });
})();
